import { render, staticRenderFns } from "./FormCaptureButton.vue?vue&type=template&id=1360a10d&scoped=true&"
import script from "./FormCaptureButton.vue?vue&type=script&lang=js&"
export * from "./FormCaptureButton.vue?vue&type=script&lang=js&"
import style0 from "./FormCaptureButton.vue?vue&type=style&index=0&id=1360a10d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1360a10d",
  null
  
)

export default component.exports